import { UseFormReturn } from 'react-hook-form';

import { Flex } from 'components/layout';
import { Typography } from 'components/typography';

import { StopSchedulingCard } from '../components/StopSchedulingCard';
import { TransportProFormLoad, TransportProSchedulingStop } from '../types';

type StopsSectionProps = {
  formMethods: UseFormReturn<TransportProFormLoad>;
  stops: TransportProSchedulingStop[];
};

export function StopsSection({ formMethods, stops }: StopsSectionProps) {
  const watchedStops = formMethods.watch('stops') ?? [];

  if (stops.length === 0) {
    return (
      <Typography variant='body-sm' className='text-neutral-500'>
        No stops found for this load.
      </Typography>
    );
  }

  return (
    <Flex direction='col' gap='md' className='w-full'>
      {stops.map((stop, index) => {
        const stopIndex = watchedStops.findIndex(
          (s) =>
            s.stopNumber === stop.stopNumber && s.stopType === stop.stopType
        );

        return (
          <StopSchedulingCard
            key={`${stop.stopType}-${stop.stopNumber}-${stop.loadID}`}
            stopIndex={stopIndex >= 0 ? stopIndex : index}
            stop={stop}
            formMethods={formMethods}
          />
        );
      })}
    </Flex>
  );
}
